module.exports = __webpack_public_path__ + "static/media/loader_white.94746e82.gif";